import React from 'react';
import { SmartphoneIcon } from 'lucide-react';
const CTASection = () => {
  return <section id="download" className="py-16 md:py-24 bg-[#E87B5C]" data-id="element-23">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-24">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8 md:gap-16" data-id="element-25">
          <div className="md:w-1/2" data-id="element-26">
            <h2 className="text-4xl md:text-5xl font-semibold mb-6 text-white" style={{
            fontFamily: "'DM Serif Display', serif"
          }} data-id="element-27">
              Transform Your Communication Today
            </h2>
            <p className="text-xl text-white/95 mb-8 max-w-lg" data-id="element-28">
              Download Emigo for{' '}
              <strong data-id="element-29">
                <em data-id="element-30">Free</em>
              </strong>
              . No credit card required and no personal information needed: we
              don't ask for your name, age, location, or anything else. Just
              onboard Emigo and start typing.
            </p>
            <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4" data-id="element-31">
              <a href="#" className="inline-block hover:opacity-90 transition-opacity" data-id="element-32">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/55BSmF1FDX8kQyzwZAZdd8/download-on-the-app-store.svg" alt="Download on the App Store" className="h-14" data-id="element-33" />
              </a>
              <div className="flex items-center justify-center bg-white/90 text-gray-700 h-14 px-6 rounded-lg cursor-not-allowed shadow-sm" data-id="element-34">
                <SmartphoneIcon className="mr-2 h-6 w-6" data-id="element-35" />
                <div data-id="element-36">
                  <div className="text-[10px] leading-tight" data-id="element-37">Coming Soon</div>
                  <div className="text-base font-semibold leading-tight" data-id="element-38">
                    Google Play
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="md:w-1/2 relative" data-id="element-39">
            <div className="relative max-w-xl mx-auto p-10 rounded-2xl bg-white/95 backdrop-blur-md shadow-2xl border border-white/40" data-id="element-40">
              {/* Decorative large quote mark */}
              <div className="absolute -top-4 left-8 text-[#E87B5C]/15 text-[120px] leading-none pointer-events-none select-none" style={{
              fontFamily: "'DM Serif Display', serif"
            }} aria-hidden="true" data-id="element-41">
                {'\u201C'}
              </div>
              <blockquote className="relative z-10" data-id="element-42">
                <p className="text-xl md:text-2xl text-gray-800 leading-relaxed mb-6 font-normal" style={{
                fontFamily: "'DM Serif Display', serif"
              }} data-id="element-43">
                  {'\u201C'}A single message can break a bond or build one.
                  Emigo turns impulse into reflection, helping you break the
                  cycle and choose connection, one conversation at a time.
                  {'\u201D'}
                </p>
                <div className="flex items-center gap-3" data-id="element-44">
                  <div className="h-px w-10 bg-[#E87B5C]" data-id="element-45"></div>
                  <p className="text-sm font-semibold uppercase tracking-widest text-[#E87B5C]" data-id="element-46">
                    The Emigo Philosophy
                  </p>
                </div>
              </blockquote>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default CTASection;